const COLOR_AR_TO_EN = {
  'أخضر': 'green', 'اخضر': 'green',
  'بيج': 'beige',
  'أزرق': 'blue', 'ازرق': 'blue',
  'بني': 'brown',
  'أحمر': 'red', 'احمر': 'red',
  'أسود': 'black', 'اسود': 'black',
  'أبيض': 'white', 'ابيض': 'white',
  'وردي': 'pink',
  'أصفر': 'yellow', 'اصفر': 'yellow',
  'بحري': 'navy', 'نيفي': 'navy',
  'رمادي': 'grey',
  'بردو': 'bordo',
  'برتقالي': 'orange',
  'زيتي': 'olive',
  'فستقي': 'pistachio',
  'بيبي بلو': 'baby-blue',
  'كوفي': 'coffee',
  'فيزيون': 'vizyon',
  'أخضر فاتح': 'light-green', 'اخضر فاتح': 'light-green',
  'أخضر زيتي': 'olive-green', 'اخضر زيتي': 'olive-green',
};

const COLOR_EN_TO_AR = {
  'green': 'أخضر',
  'beige': 'بيج',
  'blue': 'أزرق',
  'brown': 'بني',
  'red': 'أحمر',
  'black': 'أسود',
  'white': 'أبيض',
  'pink': 'وردي',
  'yellow': 'أصفر',
  'navy': 'بحري',
  'grey': 'رمادي',
  'gray': 'رمادي',
  'bordo': 'بردو',
  'orange': 'برتقالي',
  'olive': 'زيتي',
  'pistachio': 'فستقي',
  'baby-blue': 'بيبي بلو',
  'baby blue': 'بيبي بلو',
  'coffee': 'كوفي',
  'vizyon': 'فيزيون',
  'light-green': 'أخضر فاتح',
  'light green': 'أخضر فاتح',
  'olive-green': 'أخضر زيتي',
  'olive green': 'أخضر زيتي',
};

const OPTION_LABEL_AR = {
  'color': 'اللون',
  'colour': 'اللون',
  'size': 'المقاس',
  'material': 'الخامة',
  'style': 'الستايل',
};

class ColorSwatchesSliderSync {
  constructor() {
    this.originalSlides = new Map();
    this.originalThumbs = new Map();
    this.initialized = new WeakSet();
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    setTimeout(() => {
      this.storeOriginals();
      this.translateDisplay();
    }, 800);

    document.addEventListener('click', (e) => {
      const swatch = e.target.closest('.product__color-swatches--js');
      if (!swatch) return;

      const colorValue = swatch.dataset.value || swatch.dataset.color;
      if (!colorValue) return;

      setTimeout(() => {
        this.handleSwatchClick(swatch, colorValue);
        this.translateDisplay();
      }, 10);
    });

    // Re-translate when variant changes update the DOM
    this.observeVariantChanges();
  }

  translateDisplay() {
    // 1. Translate color values in .option_value spans (e.g. "Color: Green")
    document.querySelectorAll('.option_value').forEach((el) => {
      const text = el.textContent.trim().toLowerCase().replace(/-/g, ' ');
      const ar = COLOR_EN_TO_AR[text] || COLOR_EN_TO_AR[el.textContent.trim().toLowerCase()];
      if (ar) el.textContent = ar;
    });

    // 2. Translate tooltip text inside color swatches
    document.querySelectorAll(
      '.product__color-swatch .tooltip-content, .product__color-swatches--js .tooltip-content'
    ).forEach((el) => {
      const text = el.textContent.trim().toLowerCase().replace(/-/g, ' ');
      const ar = COLOR_EN_TO_AR[text] || COLOR_EN_TO_AR[el.textContent.trim().toLowerCase()];
      if (ar) el.textContent = ar;
    });

    // 3. Translate option name labels (the "Color:" / "Size:" text nodes)
    // The text node is a sibling of .option_value inside the same parent
    document.querySelectorAll('.option_value').forEach((el) => {
      const parent = el.parentElement;
      if (!parent) return;
      Array.from(parent.childNodes).forEach((node) => {
        if (node.nodeType !== Node.TEXT_NODE) return;
        let text = node.textContent;
        let changed = false;
        for (const [en, ar] of Object.entries(OPTION_LABEL_AR)) {
          const regex = new RegExp(`\\b${en}\\b`, 'gi');
          if (regex.test(text)) {
            text = text.replace(regex, ar);
            changed = true;
          }
        }
        if (changed) node.textContent = text;
      });
    });

    // 4. Translate dropdown option labels (non-swatch variant selectors)
    document.querySelectorAll('swatch-dropdown-item label, .product__item-option').forEach((el) => {
      const text = el.textContent.trim().toLowerCase().replace(/-/g, ' ');
      const ar = COLOR_EN_TO_AR[text] || COLOR_EN_TO_AR[el.textContent.trim().toLowerCase()];
      if (ar) el.textContent = ar;
    });
  }

  observeVariantChanges() {
    const targets = document.querySelectorAll('.option_value');
    if (!targets.length) return;

    const observer = new MutationObserver(() => this.translateDisplay());
    targets.forEach((el) => {
      observer.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  storeOriginals() {
    document.querySelectorAll('slide-with-thumbs').forEach((slider) => {
      if (this.initialized.has(slider)) return;

      const mainWrapper = slider.querySelector('.media-main-swiper .swiper-wrapper');
      const thumbWrapper = slider.querySelector('.media-thumb-swiper .swiper-wrapper');

      if (mainWrapper && mainWrapper.children.length > 0) {
        this.originalSlides.set(
          slider,
          Array.from(mainWrapper.children).map((el) => el.cloneNode(true))
        );
      }
      if (thumbWrapper && thumbWrapper.children.length > 0) {
        this.originalThumbs.set(
          slider,
          Array.from(thumbWrapper.children).map((el) => el.cloneNode(true))
        );
      }

      this.initialized.add(slider);
    });
  }

  handleSwatchClick(swatch, colorValue) {
    const section =
      swatch.closest('[id^="MainProduct-"]') ||
      swatch.closest('.sec__featured-product');
    if (!section) return;

    const slider = section.querySelector('slide-with-thumbs');
    if (!slider) return;

    if (!this.initialized.has(slider)) {
      this.storeOriginals();
    }

    this.filterSlider(slider, colorValue);
  }

  filterByAltText(slides, colorValue) {
    const color = colorValue.toLowerCase().trim().replace(/['"]/g, '');
    const colorEn = (COLOR_AR_TO_EN[color] || COLOR_AR_TO_EN[colorValue.trim()] || color).toLowerCase();

    const matches = (alt, term) =>
      alt === term ||
      alt.startsWith(term + ' ') ||
      alt.startsWith(term + '-') ||
      alt.includes(' ' + term) ||
      alt.includes('-' + term);

    return slides.filter((slide) => {
      const img = slide.querySelector('img');
      if (!img) return false;
      const alt = (img.alt || '').toLowerCase().trim();
      return matches(alt, color) || (colorEn !== color && matches(alt, colorEn));
    });
  }

  filterSlider(slider, colorValue) {
    const originalMain = this.originalSlides.get(slider);
    const originalThumbs = this.originalThumbs.get(slider);

    if (!originalMain || originalMain.length === 0) return;

    const matchedMain = this.filterByAltText(originalMain, colorValue);
    const matchedThumbs = originalThumbs
      ? this.filterByAltText(originalThumbs, colorValue)
      : [];

    if (matchedMain.length === 0) {
      console.warn(
        `[ColorSync] No images found for "${colorValue}". Set alt text of each image to its color name in Shopify Admin.`
      );
      return;
    }

    const mainWrapper = slider.querySelector('.media-main-swiper .swiper-wrapper');
    if (mainWrapper) {
      mainWrapper.innerHTML = '';
      matchedMain.forEach((slide) => mainWrapper.appendChild(slide.cloneNode(true)));
    }

    const thumbWrapper = slider.querySelector('.media-thumb-swiper .swiper-wrapper');
    if (thumbWrapper && matchedThumbs.length > 0) {
      thumbWrapper.innerHTML = '';
      matchedThumbs.forEach((thumb) => thumbWrapper.appendChild(thumb.cloneNode(true)));
    }

    setTimeout(() => {
      if (slider.globalSlide) {
        slider.globalSlide.update();
        slider.globalSlide.slideTo(0, 0);
      }
      if (slider.thumbnailSlide) {
        slider.thumbnailSlide.update();
        slider.thumbnailSlide.slideTo(0, 0);
      }
      if (window.initLazyloadItem) window.initLazyloadItem();
      if (window.BlsAnimations && window.BlsAnimations.innit) {
        window.BlsAnimations.innit();
      }
    }, 50);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.colorSwatchesSliderSync = new ColorSwatchesSliderSync();
  });
} else {
  window.colorSwatchesSliderSync = new ColorSwatchesSliderSync();
}
